import{getObjectTokenType}from"../tokens/main.js";

import{throwTokenError}from"./throw.js";


export const normalizeToken=(token,query)=>{
const tokenType=getValidTokenType(token,query);
return tokenType.normalize(token)
};


export const getValidTokenType=(token,query)=>{
const tokenType=getObjectTokenType(token);
validateToken(tokenType,token,query);
return tokenType
};

const validateToken=(tokenType,token,query)=>{
if(tokenType===undefined){
throwTokenError(
query,
token,
`It must be one of the following:
 - a property name string
 - an array index integer, positive or negative
 - a property name regular expression
 - { type: "any" }
 - { type: "slice", from: integer, to: integer }`
)
}
};